<template>
  <div class="flex flex-col">
    <OrganismsNavPwaMobileNav v-if="isPWAInstalled() && showHeader" class="block md:hidden"/>
    <div
      class="flex flex-1 flex-col bg-white md:mt-[7.5rem] mt-[4rem]"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
const showHeader = useState('pwa-auth-pages:showHeader', () => false)
</script>

<style scoped>

</style>